import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b854031"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "progress" }
const _hoisted_3 = { class: "footer__inner u-inner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "footer__label" }, "Contents", -1))
const _hoisted_5 = { class: "foooter__select" }
const _hoisted_6 = { class: "footer__selected-title" }
const _hoisted_7 = { class: "footer__chapters" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "footer__link",
  href: "https://assets.kpmg/content/dam/kpmg/xx/pdf/2022/10/voices-on-2030-fs-reinvented-web.pdf",
  target: "_top",
  download: "",
  "data-cursor": "small",
  "data-theme": "dark"
}, " Download full report ", -1))


const __default__ = { name: 'FooterLayout' };

import {
  ref,
  watch,
  onMounted,
  onUnmounted,
} from 'vue';

import { gsap } from 'gsap';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from '@/store';
import Icon from '@/components/Icon.vue';
import SVGArrowExpand from '@/svgs/arrow-expand.svg';
import chaptersData from '@/chapters';

interface Chapter {
  title: string;
  index: number;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const progressBarRef = ref<HTMLElement>();

const chapters = chaptersData.map((chapter, index) => ({
  title: chapter.title,
  index,
}));

const selected = ref<Chapter | undefined>();
const isSelectOepen = ref(false);

const onEnter = (element: HTMLElement) => {
  gsap.to(element, { opacity: 1, duration: 0.3 });
};

const onLeave = async (element: HTMLElement, done: () => void) => {
  await gsap.to(element, { opacity: 0, duration: 0.3 });
  done();
};

const handleChapterClick = () => {
  isSelectOepen.value = !isSelectOepen.value;
};

const handleChapterSelect = (index: number) => {
  isSelectOepen.value = false;
  selected.value = chapters[index];

  if (route.name !== 'Home') {
    // router.push(`/?q=${index + 1}`);
    store.dispatch('setCurrentChapter', index + 1);
    router.push('/');
  } else {
    const chapterElement = document.querySelector(`[data-chapter="${index + 1}"]`);

    if (chapterElement) {
      const offset = chapterElement.getBoundingClientRect();
      const top = offset.top + window.scrollY;
      gsap.to(document.documentElement, { scrollTo: top });
    }
  }
};

const scrollProgress = () => {
  if (!progressBarRef.value) return;
  const html = document.documentElement;
  const progressBar = progressBarRef.value;
  const { clientHeight, scrollHeight, scrollTop } = html;
  const percentage = scrollTop / (scrollHeight - clientHeight);
  gsap.to(progressBar, {
    width: `${percentage * 100}%`,
  });
};

onMounted(() => {
  window.addEventListener('scroll', scrollProgress, false);
});

onUnmounted(() => {
  window.removeEventListener('scroll', scrollProgress, false);
});

watch(() => store.state.status.currentChapter, () => {
  const chapterNumber = store.state.status.currentChapter;
  const targetChapter = chapters[Number(chapterNumber) - 1];
  selected.value = targetChapter || undefined;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "progress__value",
        ref_key: "progressBarRef",
        ref: progressBarRef
      }, null, 512)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: _normalizeClass(["footer__selected-chapter", !selected.value && 'is-empty']),
          "data-cursor": "small",
          onClick: handleChapterClick
        }, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(selected.value ? selected.value.title : 'Select pillar'), 1),
          _createVNode(Icon, {
            class: _normalizeClass(["footer__icon", isSelectOepen.value && 'is-open'])
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(SVGArrowExpand))
            ]),
            _: 1
          }, 8, ["class"])
        ], 2),
        _createVNode(_Transition, {
          onEnter: onEnter,
          onLeave: onLeave
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chapters), (chapter) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: chapter.title,
                  class: "footer__list"
                }, [
                  _createElementVNode("button", {
                    class: "footer__button",
                    onClick: () => handleChapterSelect(chapter.index),
                    "data-cursor": "small"
                  }, _toDisplayString(chapter.title), 9, _hoisted_8)
                ]))
              }), 128))
            ], 512), [
              [_vShow, isSelectOepen.value]
            ])
          ]),
          _: 1
        })
      ]),
      _hoisted_9
    ])
  ]))
}
}

})